export enum FontSizeEnum {
  LARGE_PROMINENT,
  LARGE,
  MEDIUM,
  MEDIUM_PROMINENT,
  SMALL,
}

export enum FontTypeEnum {
  DISPLAY,
  HEADLINE,
  TITLE,
  LABEL,
  BODY,
}
